export enum PSSErrors {
  NotEnoughAvailability = "Not enough availabilities",
  PriceNotInProductCategory = "Price not found in category",
  MultiInsertError = "Some pss were not saved",
  NoTSInPSS = "PSS has no timeslot",
  NoRetailInPSS = "PSS has no retail option",
  HasNoUUID = "PSS has no UUID",
  UnavailableMandatoryAddon = "PSS has a mandatory addon with no timeslots",
  TimeslotCategoryMismatch = "PSS timeslot belongs to another category",
}
